module.exports = __webpack_public_path__ + "static/media/WhyTheWait.6da6219e.png";